import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Cleaning.css";

function Cleaning() {
  const [search, setSearch] = useState("");
  const role = localStorage.getItem("role");
  const username = localStorage.getItem("username") || "Unknown";
  const canEdit = role === "admin" || role === "superadmin";
  const canDelete = role === "superadmin";
  // Any logged-in role (user, admin, superadmin) can add data now.
  const canAdd = role === "user" || role === "admin" || role === "superadmin";

  const [dutyReports, setDutyReports] = useState([]);
  const [repairs, setRepairs] = useState([]);

  const [editingDutyId, setEditingDutyId] = useState(null);
  const [editingRepairId, setEditingRepairId] = useState(null);

  const [dutyForm, setDutyForm] = useState({
    date: "",
    location: "",
    headCount: "",
    paymentPerPerson: "",
    totalCost: "",
    remarks: "",
  });

  const [repairForm, setRepairForm] = useState({
    date: "",
    location: "",
    description: "",
    image: "",
    completionDate: "",
    responsibility: "",
    status: "Pending",
    remarks: "",
  });

  useEffect(() => {
    fetchDutyReports();
    fetchRepairs();
  }, []);

  const addHistory = async (action, description) => {
    try {
      await axios.post("https://hrpsc.swisstekaluminium.com/api/history", {
        module: "Cleaning & Repairs",
        action,
        description,
        username,
        role,
      });
    } catch (error) {
      console.log("History Save Error:", error);
    }
  };

  const fetchDutyReports = async () => {
    try {
      const res = await axios.get("https://hrpsc.swisstekaluminium.com/api/cleaning/duty");
      setDutyReports(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRepairs = async () => {
    try {
      const res = await axios.get("https://hrpsc.swisstekaluminium.com/api/cleaning/repair");
      setRepairs(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDutyChange = (e) => {
    const { name, value } = e.target;

    const updatedForm = {
      ...dutyForm,
      [name]: value,
    };

    if (name === "headCount" || name === "paymentPerPerson") {
      const headCount = Number(
        name === "headCount" ? value : updatedForm.headCount
      );

      const paymentPerPerson = Number(
        name === "paymentPerPerson" ? value : updatedForm.paymentPerPerson
      );

      updatedForm.totalCost = headCount * paymentPerPerson;
    }

    setDutyForm(updatedForm);
  };

  const handleRepairChange = (e) => {
    setRepairForm({
      ...repairForm,
      [e.target.name]: e.target.value,
    });
  };
    const saveDutyReport = async () => {
    if (!dutyForm.location) {
      alert("Location is required");
      return;
    }

    try {
      const payload = {
        date: dutyForm.date || "",
        location: dutyForm.location || "",
        headCount: Number(dutyForm.headCount || 0),
        paymentPerPerson: Number(dutyForm.paymentPerPerson || 0),
        totalCost: Number(dutyForm.totalCost || 0),
        remarks: dutyForm.remarks || "",
      };

      if (editingDutyId) {
        await axios.put(
          `https://hrpsc.swisstekaluminium.com/api/cleaning/duty/${editingDutyId}`,
          payload
        );

        await addHistory(
          "Updated Duty Report",
          `Duty report updated for ${dutyForm.location}`
        );

        alert("Duty Report Updated");
      } else {
        await axios.post("https://hrpsc.swisstekaluminium.com/api/cleaning/duty", payload);

        await addHistory(
          "Added Duty Report",
          `Duty report added for ${dutyForm.location}`
        );

        alert("Duty Report Added");
      }

      fetchDutyReports();
      clearDutyForm();
    } catch (error) {
      console.log(error.response?.data || error);
      alert(error.response?.data?.message || "Error Saving Duty Report");
    }
  };

  const saveRepair = async () => {
    if (!repairForm.location) {
      alert("Location is required");
      return;
    }

    try {
      const payload = {
        date: repairForm.date || "",
        location: repairForm.location || "",
        description: repairForm.description || "",
        image: repairForm.image || "",
        completionDate: repairForm.completionDate || "",
        responsibility: repairForm.responsibility || "",
        status: repairForm.status || "Pending",
        remarks: repairForm.remarks || "",
      };

      if (editingRepairId) {
        await axios.put(
          `https://hrpsc.swisstekaluminium.com/api/cleaning/repair/${editingRepairId}`,
          payload
        );

        await addHistory(
          "Updated Repair",
          `Repair updated for ${repairForm.location}`
        );

        alert("Repair Updated");
      } else {
        await axios.post("https://hrpsc.swisstekaluminium.com/api/cleaning/repair", payload);

        await addHistory(
          "Added Repair",
          `Repair added for ${repairForm.location}`
        );

        alert("Repair Added");
      }

      fetchRepairs();
      clearRepairForm();
    } catch (error) {
      console.log(error.response?.data || error);
      alert(error.response?.data?.message || "Error Saving Repair");
    }
  };

  const editDuty = (item) => {
    setEditingDutyId(item._id);

    setDutyForm({
      date: item.date || "",
      location: item.location || "",
      headCount: item.headCount || "",
      paymentPerPerson: item.paymentPerPerson || "",
      totalCost: item.totalCost || "",
      remarks: item.remarks || "",
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const editRepair = (item) => {
    setEditingRepairId(item._id);

    setRepairForm({
      date: item.date || "",
      location: item.location || "",
      description: item.description || "",
      image: item.image || "",
      completionDate: item.completionDate || "",
      responsibility: item.responsibility || "",
      status: item.status || "Pending",
      remarks: item.remarks || "",
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const deleteDuty = async (id) => {
    if (!window.confirm("Delete this duty report?")) return;

    try {
      await axios.delete(`https://hrpsc.swisstekaluminium.com/api/cleaning/duty/${id}`);

      await addHistory(
        "Deleted Duty Report",
        "Duty report deleted"
      );

      fetchDutyReports();
      alert("Duty Report Deleted");
    } catch (error) {
      console.log(error);
      alert("Error Deleting Duty Report");
    }
  };

  const deleteRepair = async (id) => {
    if (!window.confirm("Delete this repair?")) return;

    try {
      await axios.delete(`https://hrpsc.swisstekaluminium.com/api/cleaning/repair/${id}`);

      await addHistory(
        "Deleted Repair",
        "Repair record deleted"
      );

      fetchRepairs();
      alert("Repair Deleted");
    } catch (error) {
      console.log(error);
      alert("Error Deleting Repair");
    }
  };

  const clearDutyForm = () => {
    setEditingDutyId(null);

    setDutyForm({
      date: "",
      location: "",
      headCount: "",
      paymentPerPerson: "",
      totalCost: "",
      remarks: "",
    });
  };

  const clearRepairForm = () => {
    setEditingRepairId(null);

    setRepairForm({
      date: "",
      location: "",
      description: "",
      image: "",
      completionDate: "",
      responsibility: "",
      status: "Pending",
      remarks: "",
    });
  };

  const filteredDutyReports = dutyReports.filter((item) =>
    item.location?.toLowerCase().includes(search.toLowerCase())
  );

  const filteredRepairs = repairs.filter((item) =>
    item.location?.toLowerCase().includes(search.toLowerCase())
  );

  const totalCost = dutyReports.reduce(
    (sum, item) => sum + Number(item.totalCost || 0),
    0
  );
    return (
    <div className="cleaning-page">
      <h1 className="page-title">
        Cleaning & Garden Maintenance & Repairs
      </h1>

      <div className="dashboard-cards">
        <div className="dashboard-card">
          <h3>Total Duty Reports</h3>
          <h1>{dutyReports.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Total Repairs</h3>
          <h1>{repairs.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Year Total Cost</h3>
          <h1>Rs.{totalCost}</h1>
        </div>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search Location"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <button className="clear-btn" onClick={() => setSearch("")}>
          Clear
        </button>
      </div>

      <div className="table-container">
        <h2 className="table-title">Duty Reports</h2>

        {/* Add form: user, admin, and superadmin can all add data now.
            The same form is reused for editing
            (editingDutyId gets set by editDuty). */}
        {(canAdd || editingDutyId) && (
          <>
            <div className="form-container">
              <input
                type="date"
                name="date"
                value={dutyForm.date}
                onChange={handleDutyChange}
              />

              <input
                type="text"
                name="location"
                placeholder="Location"
                value={dutyForm.location}
                onChange={handleDutyChange}
              />

              <input
                type="number"
                name="headCount"
                placeholder="Head Count"
                value={dutyForm.headCount}
                onChange={handleDutyChange}
              />

              <input
                type="number"
                name="paymentPerPerson"
                placeholder="Payment Per Person"
                value={dutyForm.paymentPerPerson}
                onChange={handleDutyChange}
              />

              <input
                type="number"
                name="totalCost"
                placeholder="Total Cost"
                value={dutyForm.totalCost}
                onChange={handleDutyChange}
              />

              <input
                type="text"
                name="remarks"
                placeholder="Remarks"
                value={dutyForm.remarks}
                onChange={handleDutyChange}
              />
            </div>

            <div className="button-group">
              <button className="add-btn" onClick={saveDutyReport}>
                {editingDutyId ? "Update Duty Report" : "Add Duty Report"}
              </button>

              <button className="clear-btn" onClick={clearDutyForm}>
                Clear Form
              </button>
            </div>
          </>
        )}
      </div>

      <div className="table-container">
        <h2 className="table-title">Duty Report Table</h2>

        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Location</th>
              <th>Head Count</th>
              <th>Payment</th>
              <th>Total Cost</th>
              <th>Remarks</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredDutyReports.map((item) => (
              <tr key={item._id}>
                <td>{item.date}</td>
                <td>{item.location}</td>
                <td>{item.headCount}</td>
                <td>{item.paymentPerPerson}</td>
                <td>Rs.{item.totalCost}</td>
                <td>{item.remarks}</td>

                <td>
                  <div className="action-buttons">
                    {canEdit && (
                      <button
                        className="edit-btn"
                        onClick={() => editDuty(item)}
                      >
                        Edit
                      </button>
                    )}

                    {canDelete && (
                      <button
                        className="delete-btn"
                        onClick={() => deleteDuty(item._id)}
                      >
                        Delete
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="table-container">
        <h2 className="table-title">Repairs</h2>

        {/* Add form: user, admin, and superadmin can all add data now.
            The same form is reused for editing
            (editingRepairId gets set by editRepair). */}
        {(canAdd || editingRepairId) && (
          <>
            <div className="form-container">
              <input
                type="date"
                name="date"
                value={repairForm.date}
                onChange={handleRepairChange}
              />

              <input
                type="text"
                name="location"
                placeholder="Location"
                value={repairForm.location}
                onChange={handleRepairChange}
              />

              <input
                type="text"
                name="description"
                placeholder="Description"
                value={repairForm.description}
                onChange={handleRepairChange}
              />

              <input
                type="text"
                name="image"
                placeholder="Image URL"
                value={repairForm.image}
                onChange={handleRepairChange}
              />

              <input
                type="date"
                name="completionDate"
                value={repairForm.completionDate}
                onChange={handleRepairChange}
              />

              <input
                type="text"
                name="responsibility"
                placeholder="Responsibility"
                value={repairForm.responsibility}
                onChange={handleRepairChange}
              />

              <select
                name="status"
                value={repairForm.status}
                onChange={handleRepairChange}
              >
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
              </select>

              <input
                type="text"
                name="remarks"
                placeholder="Remarks"
                value={repairForm.remarks}
                onChange={handleRepairChange}
              />
            </div>

            <div className="button-group">
              <button className="add-btn" onClick={saveRepair}>
                {editingRepairId ? "Update Repair" : "Add Repair"}
              </button>

              <button className="clear-btn" onClick={clearRepairForm}>
                Clear Form
              </button>
            </div>
          </>
        )}
      </div>

      <div className="table-container">
        <h2 className="table-title">Repair Table</h2>

        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Location</th>
              <th>Description</th>
              <th>Image</th>
              <th>Completion</th>
              <th>Responsibility</th>
              <th>Status</th>
              <th>Remarks</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredRepairs.map((item) => (
              <tr key={item._id}>
                <td>{item.date}</td>
                <td>{item.location}</td>
                <td>{item.description}</td>

                <td>
                  {item.image && (
                    <img src={item.image} alt="repair" width="70" />
                  )}
                </td>

                <td>{item.completionDate}</td>
                <td>{item.responsibility}</td>

                <td>
                  <span
                    className={
                      item.status === "Completed"
                        ? "completed-status"
                        : "pending-status"
                    }
                  >
                    {item.status}
                  </span>
                </td>

                <td>{item.remarks}</td>

                <td>
                  <div className="action-buttons">
                    {canEdit && (
                      <button
                        className="edit-btn"
                        onClick={() => editRepair(item)}
                      >
                        Edit
                      </button>
                    )}

                    {canDelete && (
                      <button
                        className="delete-btn"
                        onClick={() => deleteRepair(item._id)}
                      >
                        Delete
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Cleaning;